//Scrollspy
!function($,window,document){$.fn.extend({scrollspy:function(options){var defaults={namespace:'scrollspy',activeClass:'active',animate:!1,duration:1e3,offset:0,container:window,replaceState:!1};options=$.extend({},defaults,options);var add=function(ex1,ex2){return parseInt(ex1,10)+parseInt(ex2,10)},findElements=function(links){for(var elements=[],i=0;i<links.length;i++){var link=links[i],hash=$(link).attr('href'),element=$(hash);if(element.length>0){var top=Math.floor(element.offset().top),bottom=top+Math.floor(element.outerHeight());elements.push({element:element,hash:hash,top:top,bottom:bottom})}}return elements},findLink=function(links,hash){for(var i=0;i<links.length;i++){var link=$(links[i]);if(link.attr('href')===hash){return link}else{return false}}},resetClasses=function(links){for(var i=0;i<links.length;i++)$(links[i]).parent().removeClass(options.activeClass)},scrollArea='';return this.each(function(){for(var element=this,container=$(options.container),links=$(element).find('a'),i=0;i<links.length;i++){var link=links[i];$(link).on('click',function(e){var target=$(this).attr('href'),$target=$(target);if($target.length>0){var top=add($target.offset().top,options.offset);options.animate?$('html, body').animate({scrollTop:top},options.duration):window.scrollTo(0,top),e.preventDefault()}})}resetClasses(links);var elements=findElements(links),trackChanged=function(){for(var link,position={top:add($(this).scrollTop(),Math.abs(options.offset)),left:$(this).scrollLeft()},i=0;i<elements.length;i++){var current=elements[i];if(position.top>=current.top&&position.top<current.bottom){var hash=current.hash;link=findLink(links,hash);if(link){options.onChange&&scrollArea!==hash&&(options.onChange(current.element,$(element),position),scrollArea=hash),options.replaceState&&history.replaceState({},'','/'+hash),resetClasses(links),link.parent().addClass(options.activeClass);break}}}!link&&'exit'!==scrollArea&&options.onExit&&(options.onExit($(element),position),resetClasses(links),scrollArea='exit',options.replaceState&&history.replaceState({},'','/'))};container.bind('scroll.'+options.namespace,function(){trackChanged()}),$(document).ready(function(){trackChanged()})})}})}(jQuery,window,document);

import {validateZip} from '../../refactor/assets/scripts/utilities/validation';

//responsive tables
(function ($) {

    'use strict';

    var $window_width = $(window).width();

    function validateEmail($email) {

        var emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;

        return emailReg.test($email);

    }

    function modalErrors(errors, modal) {

        modal.find('.errors').empty();

        $.each(errors, function (i) {

            modal.find('.errors').append('<p class="alert alert-danger">' + errors[i] + '</p>');

        });

    }

    function control_sidebar_scroll() {

        var content_top = $('.content').offset().top;

        $(window).on('scroll', function () {

            var $window_width = $(window).width();

            if ($window_width <= 1023) {

                var $window_scroll = $(window).scrollTop();

                if ($window_scroll >= content_top) {

                    $('.sidebar').addClass('sticky').stop().fadeIn(500);

                } else {

                    $('.sidebar').stop().fadeOut(500, function () {

                        $(this).removeClass('sticky');

                    });

                }

            } else {

                $('.sidebar').removeClass('sticky').show();

            }

        });

    }

    // Page hero expert element
    function shift_content() {

        var $window_width = $(window).width();

        if ($window_width <= 767) {

            if (!$('.page-hero .expert-image h4').length) {

                $('.page-hero .expert-bio h4').appendTo($('.page-hero .expert-image'));

            }

            if (!$('.page-hero .expert-image .expert-stars').length) {

                $('.page-hero .expert-content .expert-stars').appendTo($('.page-hero .expert-image'));

            }

            if (!$('.page-hero .expert-image .expert-header').length) {

                $('.page-hero .expert-image .expert-stars, .page-hero .expert-image h4').wrapAll('<div class="expert-header"></div>');

            }


        } else {

            if (!$('.page-hero .expert-bio h4').length) {

                $('.page-hero .expert-image h4').appendTo($('.page-hero .expert-bio'));

            }

            if (!$('.page-hero .expert-content .expert-stars').length) {

                $('.page-hero .expert-image .expert-stars').appendTo($('.page-hero .expert-content'));

            }

            if ($('.page-hero .expert-image .expert-header').length) {

                $('.page-hero .expert-image .expert-header').remove();

            }

        }

    }

    $(function () {

        //temp function to style tables to new basic format
        $('.thead-dark').each(function () {

            //console.log('styles for basic');
            var _table = $(this).parent('table'),
                _thead = $(this),
                _tbody = _table.find('tbody');

            _table.removeClass().addClass('basic');
            _thead.removeClass();
            _thead.find('tr').removeClass().addClass('row100 head');
            _thead.find('th').removeClass().addClass('cell100');
            _thead.find('th:first-child').addClass('column1');

            _tbody.find('tr').removeClass().addClass('row100 body');
            _tbody.find('td, th').removeClass().addClass('cell100');
            _tbody.find('td:first-child, th:first-child').addClass('column1');

        });

        function adjustAccoladeBoxes() {

            var $windowWidth = $(window).width();

            if ($windowWidth <= 767) {

                if (!$('.accolade-boxes').first('div').hasClass('overall-rating-box')) {

                    $('.accolade-boxes .overall-rating-box').prependTo($('.accolade-boxes'));

                }

            }
            else {

                if (!$('.accolade-boxes').first('div').hasClass('stack-holder')) {

                    $('.accolade-boxes .overall-rating-box').insertAfter($('.accolade-boxes .stack-holder').eq(0));

                }

            }


        }

        if ($('.accolade-boxes').length) {

            adjustAccoladeBoxes();

            $(window).on('resize', function () {

                adjustAccoladeBoxes();

            });

        }

        function productReviewNavFixed() {

            var navTop = $('.product-review-nav-container').offset().top;

            var windowTop = $(window).scrollTop();

            if (windowTop >= navTop) {

                $('.product-review-nav').addClass('fixed');

            }
            else {

                $('.product-review-nav').removeClass('fixed');

            }

        }

        if ($('.product-review-nav').length) {

            $('body').attr('data-spy', 'scroll');

            $window_width = $(window).width();

            if ($window_width <= 767 && $('.product-review-nav-desktop').length) {

                console.log('hit');

                $('#product-review-nav .container').scrollspy({
                    offset: 200,
                    onChange: function (current) {
                        //scrollProductNav($('#product-review-nav'), current);

                console.log(current);
                    },
                });

            } else {

                console.log('no hit');

                $('#product-review-nav-desktop .container').scrollspy({
                    offset: 200,
                    onChange: function (current) {
                        //scrollProductNav($('#product-review-nav-desktop'), current);
                console.log(current);
                    },
                });

            }

            $(window).on('scroll', function () {

                productReviewNavFixed();

            });

        }


        function adjustPopularCTA() {

            var $window_width = $(window).width();

            $('.popular-product').each(function () {

                if ($window_width <= 767) {

                    if (!$(this).find('.product-img').next().hasClass('product-cta')) {

                        $(this).find('.product-cta').insertAfter($(this).find('.product-img'));

                    }

                }
                else {

                    if (!$(this).find('.product-title-cta').children('.product-cta').length) {

                        $(this).find('.product-cta').appendTo($(this).find('.product-title-cta'));

                    }

                }

            });

        }

        if ($('.popular-product').length) {

            adjustPopularCTA();

            $(window).on('resize', function () {

                adjustPopularCTA();

            });

        }

        function adjustBanner() {

            var $window_width = $(window).width(),
                banner = $('.special-deal-banner');

            if ($window_width <= 767) {

                if (!$('.custom-page-title .special-deal-banner').length) {

                    banner.addClass('active').prependTo($('.custom-page-title'));

                }

            }
            else {

                if (banner.hasClass('active')) {

                    banner.addClass('remove').insertAfter($('.page-hero'));

                }

            }

        }

        if ($('.special-deal-banner').length) {

            adjustBanner();

            $(window).on('resize', function () {

                adjustBanner();

            });

        }

        if ($('form[name="geodir-listing-search"]').length) {

            setTimeout(function () {

                $('form[name="geodir-listing-search"]').attr('action', '/senior-housing-finder/');

                $('form[name="geodir-listing-search"] input.snear').attr('placeholder', 'Enter City or Zip').val('');

            }, 250);

        }

        if ($('.page-hero .expert-element').length) {

            shift_content();

            $(window).on('resize', function () {

                shift_content();

            });

        }

        const finderBtn = document.getElementsByClassName('geodir_submit_search');
        if (typeof finderBtn !== 'undefined' && finderBtn !== null) {
            Array.prototype.forEach.call(finderBtn, function(el) {
                const
                    form = el.form,
                    zipField = form.querySelector('.senior-finder-zip');

                zipField.addEventListener('keyup', function() {
                    if(this.value.length == 5) {
                        checkForm(el, zipField, form);
                    }
                });

                el.addEventListener('click', function(e) {
                    e.preventDefault();
                    checkForm(el, zipField, form);
                });
            });
        }

        function checkForm(el, zipField, form) {
            el.classList.add('processing');

            const
                container = document.getElementsByClassName('form__widget-search')[0],
                valid = validateZip(zipField.value);

            if (!valid) {
                el.classList.remove('processing');
                container.classList.add('error');
            } else {
                form.submit();
                form.dispatchEvent(new Event('submit'));
                container.classList.remove('error');
            }
        }

        if ($('.circle-progress .circle').length) {

            $('.circle-progress .circle').circleProgress({
                value: $(this).data('value'),
                thickness: 12,
                startAngle: Math.PI / 2,
                lineCap: 'round',
                size: 150,
                fill: $(this).data('fill'),
            });

        }

        var cta = $('.journalist-cta');

        if (cta.length) {

            cta.show();

            var modal = $('#ask-expert');

            if (!modal.length) {

                //insert modal HTML if not already on page
                cta.after('<div class="modal journalist-cta-modal fade" id="ask-expert" tabindex="-1" role="dialog" aria-labelledby="ask-expert" aria-hidden="true"><div class="modal-dialog modal-lg" role= "document"><div class="modal-content"><div class="modal-header bg-faded"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-center">Ask an Expert</h3></div><div class="modal-body"><div class="expert-form"><h4>Are you a journalist or researcher writing about this topic?</h4><p>Contact us and we\'ll connect you with a SeniorLiving.org market expert on our team who can provide insights and data to support your work.</p><div class="errors"></div><div class="form-group"><input class="form-control txtName" placeholder="Name" type="text"></div><div class="form-group"><input class="form-control txtEmail" placeholder="Email" type="email"></div><div class="form-group"><input class="form-control txtOrganization" placeholder="Organization" type="text"></div><div class="form-group"><textarea class="form-control txtQuestion" placeholder="Your question" rows="4"></textarea></div></div><div class="step-complete" style="display: none;"><h4>Thank You for your inquiry.</h4><p>A SeniorLiving.org market expert will review and respond.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-info-outline btn-width-xlg" data-dismiss="modal" aria-label="Close">Cancel</button><button type="button" class="btn btn-success btn-width-xlg" id="ask-submit">Submit</button></div></div></div></div>');

                modal = $('#ask-expert');

            }

            $('#ask-submit').on('click', function () {

                var errorList = [];

                var n = modal.find('.txtName').val();
                var e = modal.find('.txtEmail').val();
                var o = modal.find('.txtOrganization').val();
                var q = modal.find('.txtQuestion').val();
                var l = window.location.href;

                if (n.length < 4) { errorList.push('Please enter your name.'); }

                if (!validateEmail(e) || e == '') { errorList.push('Please enter a valid email.'); }

                if (q.length < 10) { errorList.push('Please enter a longer question'); }

                if (errorList.length > 0) {

                    modalErrors(errorList, modal);

                }
                else {

                    $.post(window.ajaxurl, { action: 'send-question', n: n, e: e, o: o, q: q, l: l });

                    $(this).hide();

                    cta.hide();

                    $('#ask-expert .expert-form').hide();

                    $('#ask-expert .step-complete').show();

                    $('.modal-footer button[data-dismiss="modal"]').text('Close');

                }

            });

            // MODAL

            modal = $('.modal');
            var modalDialog = $('.modal-dialog')

            $('button[data-open], a[data-open], [data-open]').click(function () {

                var target = '#' + $(this).attr('data-open');

                $(target).fadeIn(200, function () {

                    modalDialog.animate({
                        opacity: 1,
                        top: 0,
                    }, 300);

                });

            });

            $('button[data-close], button.close').click(function () {

                modalDialog.animate({
                    top: '-30px',
                    opacity: 0,
                }, 300, function () {

                    modal.fadeOut(200);

                });

            });

            $(window).click(function (e) {

                if (e.target == modal[0]) {

                    modalDialog.animate({
                        top: '-30px',
                        opacity: 0,
                    }, 300, function () {

                        modal.fadeOut(200);

                    });

                }

            });

        }

        $('.list-social .ico-facebook').on('click', function () {

            var url = encodeURIComponent(window.location.href.split('?')[0]),
                height = 436,
                width = 626,
                left = window.screen.width / 2 - (width / 2 + 10),
                top = window.screen.height / 2 - (height / 2 + 50),
                settings = 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' + left + ',top=' + top + ',screenX=' + left + ',screenY=' + top + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

            window.open('https://www.facebook.com/sharer.php?u=' + url, 'sharer', settings);

        });

        $('.list-social .ico-twitter').on('click', function () {

            var title = encodeURIComponent(document.title),
                url = encodeURIComponent(window.location.href.split('?')[0]),
                height = 436,
                width = 626,
                left = window.screen.width / 2 - (width / 2 + 10),
                top = window.screen.height / 2 - (height / 2 + 50),
                settings = 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' + left + ',top=' + top + ',screenX=' + left + ',screenY=' + top + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

            window.open('https://twitter.com/intent/tweet?url=' + url + '&text=' + title, 'sharer', settings);
        });

        $('.list-social .ico-reddit').on('click', function () {

            var title = encodeURIComponent(document.title),
                url = encodeURIComponent(window.location.href.split('?')[0]),
                height = 436,
                width = 626,
                left = window.screen.width / 2 - (width / 2 + 10),
                top = window.screen.height / 2 - (height / 2 + 50),
                settings = 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' + left + ',top=' + top + ',screenX=' + left + ',screenY=' + top + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

            window.open('https://www.reddit.com/submit?url=' + url + '&t=' + title, 'sharer', settings);
        });



        // function to convert table to single tables
        function cloneTheseColumns(source, loc, selector) {
            $(source).clone().appendTo(loc);
            $(loc + ' tr').each(function () {
                $(this).children().not(selector).remove();
            });
            $(loc + ' tr:first-child .blank').add(loc + ' tr:last-child .blank').remove();
            $(loc + ' tr:first-child td').add(loc + ' tr:last-child td').attr('colspan', '2')
        }

        // create mobile table containers
        $('<div class="mobile-steps-table-wrap"><div class="independent-living"></div><div class="assisted-living"></div><div class="memory-care"></div><div class="nursing-homes"></div></div>').insertBefore('.table-responsive');
        var origTable = $('.steps .table-responsive .table');

        // clone/create tables for mobile
        cloneTheseColumns(origTable, '.independent-living', 'td:nth-child(1),td:nth-child(2)');
        cloneTheseColumns(origTable, '.assisted-living', 'td:nth-child(1),td:nth-child(3)');
        cloneTheseColumns(origTable, '.memory-care', 'td:nth-child(1),td:nth-child(4)');
        cloneTheseColumns(origTable, '.nursing-homes', 'td:nth-child(1),td:nth-child(5)');

        if (!$('body').hasClass('page-template-page-housing-lead-form')) {

            // Round GD stars to the nearest half-star
            $('.gd-rating-foreground').each(function () {
                var roundStars = (Math.round($(this).width() / $(this).parent().width() * 10) * 10) + '%';
                $(this).width(roundStars);
            });

        }

        //nav custom click event
        var clickEvent = (function () {
            if ('ontouchstart' in document.documentElement === true)
                return 'touchstart';
            else
                return 'click';
        })();

        //mobile nav
        function mobileNav() {
            $('.mobile-nav ul li a:first-child').on(clickEvent, function () {
                var subMenu = $(this).siblings('.sub-menu');
                var thisLink = $(this);
                $(subMenu).toggle(150);
                thisLink.toggleClass('open-link');
                console.log('mobileNav() funct complete');
            })
        }
        mobileNav();


        // select state h2 above listed cities
        $('body.single-post.state ul.list-cities').prevAll('h2:first').addClass('state-cities-title');

        // clear post li floats *hax all the way*
        $('.content ul').each(function () {
            var ulParentDiv = $(this).parent('div');
            var floatS = ulParentDiv.attr('style');
            if (/float/i.test(floatS)) {
                $(this).parent('div').addClass('containes_string');
            }
        });
        $('.containes_string').each(function () {
            var secondDiv = $(this).next('div.containes_string')
            $('<div class="clear"></div>').insertAfter(secondDiv);
        });

        //tabbed content js
        if ($('.tabbed-wrapper').length) {
            $('.tabbed-wrapper').each(function () {
                var theseTabs = $(this);
                var tabNavItem = theseTabs.find('.tabbed-nav li');
                var tabbedContents = theseTabs.find('.tabbed-all-content');

                tabNavItem.on(clickEvent, function () {
                    theseTabs.find('.active-tab').removeClass('active-tab');
                    $(this).addClass('active-tab');
                    var tabI = $(this).attr('data-tab-id');
                    var thisTabContent = tabbedContents.find('.tab-content[data-tab-id=' + tabI + ']');
                    thisTabContent.addClass('active-tab');
                })
            })
        }

        //show callback box
        if ($('.page-template-senior-care-specialists').length) {
            var popupflag = 0;
            $('#request-callback').on(clickEvent, function () {
                if (popupflag < 1) {
                    $('#popup').addClass('simple-popup');
                    $('<p class="h4 text-primary-dark mb-3"><strong>Request a Call Back</strong></p>').prependTo('.form-popup');
                    $('.form__actions .form__btn').val('submit');
                    $('<div class="change-mind text-primary-dark mr-lg-3">Changed your mind? </br><strong><a href="tel:866-964-9842"> Call 866-964-9842</a></strong></a></div>').appendTo('.form-popup');
                    popupflag = 1;
                }
            });
        }


        //assign 'continue to your listing' url
        if ($('body.thank-you').length) {
            var $continueTo = localStorage.getItem('form_complete_redirect');
            //$continueTo = localStorage.getItem('thank-you-return-url');
            var $fullName = localStorage.getItem('field-name');
            var $firstName = $fullName.slice(0, $fullName.indexOf(' '));
            console.log('Continue URL should be: ' + $continueTo + '.');
            $('#listing-link-row').attr('href', $continueTo);
            $('#users-name').text(', ' + $firstName);
        }

        if ($('.widget-helpline').length) {
            console.log('has idget-helpline');
            var mobile_helpline_loc = $('.main .content > p:eq( 2 )');
            mobile_helpline_loc.addClass('poop');
            $('.widget-helpline').clone().insertAfter(mobile_helpline_loc).addClass('helpline-mobile');
        }

        if ($('body.search-results').length) {
            var filtertoggle = $('#filter-toggle');
            var filterAside = $('.section__aside');
            filtertoggle.on(clickEvent, function () {
                filterAside.toggleClass('open');
                filtertoggle.toggleClass('open');
            });
        }

        if ($('body.page-template-page-faq').length) {

            control_sidebar_scroll();

            $(window).on('resize', function () {

                var $window_width = $(window).width();

                if ($window_width <= 1023) {

                    control_sidebar_scroll();

                } else {

                    $('.sidebar').removeClass('sticky').show();

                }

            });

        }

    });

})(jQuery);
